<app-si-dialog
	[hideHeader]="true"
	modalFooterClasses="si-dialog__footer--centered"
	[cancelButtonText]="initialState.buttonCancelText"
	[saveButtonText]="initialState.buttonConfirmText"
	[isLoading]="isLoading$ | async"
	[saveButtonDisabled]="isLoading$ | async"
	(close)="onConfirmation(false)"
	(save)="onConfirmation(true)"
>
	<ng-template appDialogBody>
		<div class="px-16 py-8">
			<div class="flex items-center gap-5">
				<fa-icon class="text-primary-light shrink-0 mt-0.5" [icon]="['fal', 'circle-exclamation']" size="2x"></fa-icon>
				<p class="m-0">{{initialState.promptMessage}}</p>
			</div>
		</div>
	</ng-template>
</app-si-dialog>
